/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiLongValues
 */
export interface ApiLongValues {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiLongValues
   */
  values?: Array<string>;
}

/**
 * Check if a given object implements the ApiLongValues interface.
 */
export function instanceOfApiLongValues(value: object): value is ApiLongValues {
  return true;
}

export function ApiLongValuesFromJSON(json: any): ApiLongValues {
  return ApiLongValuesFromJSONTyped(json, false);
}

export function ApiLongValuesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiLongValues {
  if (json == null) {
    return json;
  }
  return {
    values: json['values'] == null ? undefined : json['values'],
  };
}

export function ApiLongValuesToJSON(json: any): ApiLongValues {
  return ApiLongValuesToJSONTyped(json, false);
}

export function ApiLongValuesToJSONTyped(
  value?: ApiLongValues | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    values: value['values'],
  };
}
